import { render, staticRenderFns } from "./CustomFieldDeleteModal.vue?vue&type=template&id=1d164c18&"
import script from "./CustomFieldDeleteModal.vue?vue&type=script&lang=js&"
export * from "./CustomFieldDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports